import { useHasAnyFeature } from "@/hooks/useHasAnyFeature";

import { FeatureProps } from "./type";

export const Feature = ({
  required,
  children,
  fallback = null,
}: FeatureProps) => {
  const features = Array.isArray(required) ? required : [required];
  const { value: allow, isLoading } = useHasAnyFeature(...features);

  return allow ? <>{children}</> : fallback && !isLoading ? fallback : null;
};
